import React from 'react';

const NotFound = () => {
    return (
        <div className="text-danger">
            <h1>Sorry, Page not found</h1>
            <h3>404 Error!!!!</h3>
        </div>
    );
};

export default NotFound;